import { includes } from 'lodash/fp';

export const isActionKey = (event?: React.KeyboardEvent): boolean => !!event && includes(event.key, ['Enter', ' ']);
export const isMetaOrCtrlKey = (event?: React.KeyboardEvent | React.MouseEvent): boolean =>
    !!event && (event.metaKey || event.ctrlKey);
